import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-input-general',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TranslateModule,
    NgxMaskDirective,
  ],
  templateUrl: './input-general.html',
  styleUrl: './input-general.css',
})
export class InputGeneral {
  @Input() hidePassword = true;
  @Input() formControlGeneral: FormControl | AbstractControl | null = new FormControl();
  @Input() label = '';
  @Input() placeholder = '';
  @Input() mask = '';
  @Input() prefix = '';
  @Input() type = '';
  @Input() suffix = '';
  @Input() thousandSeparator = '';
  @Input() allowNegativeNumbers = false;
  @Input() maxlength = 0;
  @Input() typeInput = '';
  @Input() pattern = '';
  @Input() labelTop = true;

  isRequired(control: AbstractControl | null): boolean {
    return !!control?.hasValidator?.(Validators.required);
  }

  getInputGeneral(): FormControl {
    return this.formControlGeneral as FormControl;
  }
}
